module.exports = __webpack_public_path__ + "static/img/YB-550X.fbfdbf26.png";